import { useSelector } from 'react-redux';
const usePermission = (permissions) => {
    const session = useSelector((state) => state.session.session);
    const permitted = session.permissions.some((permission) => {
        if (typeof permissions === 'string') {
            return [permissions].indexOf(permission) !== -1;
        }
        return permissions.indexOf(permission) !== -1;
    });
    return !!permitted;
};
export default usePermission;
